module.exports = __webpack_public_path__ + "static/media/heart39.5efac2a7.svg";